namespace $.$$ {

	export type $shm_hitalama_taskmanager_status = 'todo' | 'progress' | 'done'
	export type $shm_hitalama_taskmanager_task_priority = 'low' | 'normal' | 'high'

	export type $shm_hitalama_taskmanager_task = {
		id: string
		title: string
		status: $shm_hitalama_taskmanager_status
		priority: $shm_hitalama_taskmanager_task_priority
		created_at: number
		status_changed_at?: number
		focus?: boolean
	}

	export class $shm_hitalama_taskmanager extends $.$shm_hitalama_taskmanager {

		statuses(): readonly $shm_hitalama_taskmanager_status[] {
			return [ 'todo', 'progress', 'done' ]
		}

		tasks_default(): $shm_hitalama_taskmanager_task[] {
			return [
				{
					id: 'welcome',
					title: 'Новая задача',
					status: 'todo',
					priority: 'normal',
					created_at: Date.now(),
					status_changed_at: Date.now(),
				},
			]
		}

		store_key() {
			return 'shm/hitalama/taskmanager'
		}

		@ $mol_mem
		tasks( next?: $shm_hitalama_taskmanager_task[] ) {
			const profile = this.$.$shm_hitalama_profile.current()!

			if( next !== undefined ) {
				profile.store_patch( this.store_key(), { tasks: next } )
				return next
			}

			const store = profile.store( this.store_key() ) as { tasks?: $shm_hitalama_taskmanager_task[] } | null
			if( store?.tasks ) return store.tasks

			const tasks = this.tasks_default()
			profile.store_patch( this.store_key(), { tasks } )
			return tasks
		}

		task( id: string, next?: $shm_hitalama_taskmanager_task | null ) {
			if( next === undefined ) return this.tasks().find( task => task.id === id ) ?? null

			if( next === null ) {
				this.tasks( this.tasks().filter( task => task.id !== id ) )
				return next
			}

			const tasks = this.tasks()
			const index = tasks.findIndex( task => task.id === id )

			this.tasks(
				index === -1
					? [ next, ... tasks ]
					: tasks.map( task => task.id === id ? next : task )
			)

			return next
		}

		tasks_by_status( status: $shm_hitalama_taskmanager_status, next?: $shm_hitalama_taskmanager_task[] ) {
			if( next !== undefined ) {
				this.tasks([
					... this.tasks().filter( task => task.status !== status ),
					... next,
				])
			}

			const tasks = this.tasks().filter( task => task.status === status )
			const priority_weight: Record< $shm_hitalama_taskmanager_task_priority, number > = {
				high: 0,
				normal: 1,
				low: 2,
			}
			const status_changed_at = ( task: $shm_hitalama_taskmanager_task )=> task.status_changed_at ?? task.created_at

			return tasks.sort( ( left, right )=> {
				if( status === 'done' ) return status_changed_at( right ) - status_changed_at( left )

				const priority_diff = priority_weight[ left.priority ] - priority_weight[ right.priority ]
				return priority_diff || status_changed_at( right ) - status_changed_at( left )
			} )
		}

		@ $mol_action
		task_add( next?: Event ) {
			if( next === undefined ) return null

			const created_at = Date.now()
			const task: $shm_hitalama_taskmanager_task = {
				id: `${ created_at }-${ Math.random().toString( 36 ).slice( 2 ) }`,
				title: '',
				status: 'todo',
				priority: 'normal',
				created_at,
				status_changed_at: created_at,
				focus: true,
			}

			this.tasks([ task, ... this.tasks() ])
			return next
		}

	}

}
